import React from 'react'
import classNames from 'classnames'
import {
  Paper, Tab, Tabs, Typography,
} from '@mui/material'
import { SELECT_OBSERVING_DEVICE_TYPE } from '@app/constants/routes'
import TwrDevicesList
  from '@app/containers/MyAutomation/CreateCondition/MezzoConditions/TimersConditions/SelectDeviceCommon/TwrDevices/TwrDevicesList'
import TwrDevicesByGroupList
  from '@app/containers/MyAutomation/CreateCondition/MezzoConditions/TimersConditions/SelectDeviceCommon/TwrDevices/TwrDevicesByGroupList'
import TwrDevicesByRoomsList
  from '@app/containers/MyAutomation/CreateCondition/MezzoConditions/TimersConditions/SelectDeviceCommon/TwrDevices/TwrDevicesByRoomsList'
import Wrapper from '@app/components/Common/Wrapper/Wrapper'
import NavBar from '@app/components/Common/NavBar/NavBar'
import PropTypes from '@app/components/PropTypes'
// eslint-disable-next-line max-len
// eslint-disable-next-line max-len

class SelectObservingTWRDevice extends React.Component {
  onBackClick= () => {
    const {
      navigate,
    } = this.props
    navigate(SELECT_OBSERVING_DEVICE_TYPE)
  }

  handleChange = (event, value) => {
    const { chooseTab } = this.props
    chooseTab(value)
  }

  render() {
    const {
      classes,
      isMobile,
      currentTab,
    } = this.props
    return (
      <Paper className={classNames(
        classes.wrapper,
        (navigator.userAgent.includes('WebView') || navigator.userAgent.includes('wv'))
        && classes.webView,
      )}
      >
        <NavBar
          title="create_scene"
          withButton={false}
          isMobile={isMobile}
          backClick={() => {
            this.onBackClick()
          }}
        />
        <Wrapper className={classes.titleWrapper}>
          <Typography className={classes.title}>{I18n.t('scene_web.select_observing_twr')}</Typography>
        </Wrapper>
        <Wrapper className={classes.main}>
          <Wrapper>
            <Tabs
              className={classes.deviceTabs}
              value={currentTab}
              indicatorColor="primary"
              onChange={this.handleChange}
              variant="fullWidth"
            >
              <Tab
                label="By devices"
              />
              <Tab
                label="By room"
              />
              <Tab
                label="By group"
              />
            </Tabs>
            {currentTab === 0 && (
              <TwrDevicesList />
            )}
            {currentTab === 1 && (
              <TwrDevicesByRoomsList />
            )}
            {currentTab === 2 && (
              <TwrDevicesByGroupList />
            )}
          </Wrapper>
        </Wrapper>
      </Paper>
    )
  }
}

SelectObservingTWRDevice.propTypes = {
  classes: PropTypes.object.isRequired,
  navigate: PropTypes.func.isRequired,
  isMobile: PropTypes.bool.isRequired,
  chooseTab: PropTypes.func.isRequired,
  currentTab: PropTypes.number.isRequired,
}

SelectObservingTWRDevice.displayName = 'SelectObservingTWRDevice'

export default SelectObservingTWRDevice
